import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const reciboTraspasoPdf = (values) => {
    const empresa = values.empresa;
    const insumos = values.insumos;
    const orden = values.orden;
    const logoBiwo = values.logoBiwo;
    const conceptos = insumos.map((valueConcepto, indexConcepto) => {
        return [
            { text: indexConcepto + 1, style: 'insumoCell', alignment: 'center' },
            { text: valueConcepto.clave, style: 'insumoCell', alignment: 'center' },
            { text: valueConcepto.cantidad, style: 'insumoCell', alignment: 'right' },
            { text: valueConcepto.descripcion + (valueConcepto.observaciones ? ("\n" + valueConcepto.observaciones) : ""), style: 'insumoCell', alignment: 'left' },
        ];
    });
    let nombreProyectoArriba = "";
    let nombreObra = ""
    let nombreResidente = ""
    let nombreGestor = ""
    let nombreAutorizo = ""
    let nombreConformidad = ""
    if (orden?.proyectoOrigen?.reciboTraspaso) {
        nombreProyectoArriba = orden.proyectoOrigen?.nombre ? orden.proyectoOrigen?.nombre : "";
        nombreObra = orden.proyectoDestino?.nombre ? orden.proyectoDestino?.nombre : "";
    }
    if (orden?.proyectoDestino?.reciboTraspaso) {
        nombreProyectoArriba = orden.proyectoDestino?.nombre ? orden.proyectoDestino?.nombre : "";
        nombreObra = orden.proyectoOrigen?.nombre ? orden.proyectoOrigen?.nombre : "";
    }
    if (orden.empleadoGestorId) {
        const encontrarGestor = values.empleados.find((value) => value?._id?.toString() === orden?.empleadoGestorId?.toString());
        nombreGestor = encontrarGestor ? `${encontrarGestor.nombre} ${encontrarGestor.apellidoPaterno} ${encontrarGestor.apellidoMaterno}\n` : "";
    }
    if (orden.empleadoResidenteId) {
        const encontrarResidente = values.empleados.find((value) => value?._id?.toString() === orden?.empleadoResidenteId?.toString());
        nombreResidente = encontrarResidente ? `${encontrarResidente.nombre} ${encontrarResidente.apellidoPaterno} ${encontrarResidente.apellidoMaterno}\n` : "";
    }
    if (orden.empleadoAutorizoId) {
        const encontrarAutorizo = values.empleados.find((value) => value?._id?.toString() === orden?.empleadoAutorizoId?.toString());
        nombreAutorizo = encontrarAutorizo ? `${encontrarAutorizo.nombre} ${encontrarAutorizo.apellidoPaterno} ${encontrarAutorizo.apellidoMaterno}\n` : "";
    }
    if (orden.empleadoConformidadId) {
        const encontrarConformidad = values.empleados.find((value) => value?._id?.toString() === orden?.empleadoConformidadId?.toString());
        nombreConformidad = encontrarConformidad ? `${encontrarConformidad.nombre} ${encontrarConformidad.apellidoPaterno} ${encontrarConformidad.apellidoMaterno}\n` : "";
    }
    let cancelado = {}
    if (orden.estado === 0) {
        cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } }
    }
    var dd = {
        ...cancelado,
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 50
        },
        pageMargins: [20, 20, 20, 40],
        content: [

            {
                columns: [
                    {
                        border: [false, false, false, false],
                        image: 'logo',
                        fit: [40, 40]
                    },
                    {
                        width: 'auto',
                        table: {
                            widths: ['*'],
                            body: [
                                [{ text: nombreProyectoArriba, style: 'header' }],
                                [{ text: `SERIE ${orden.serie}         FOLIO ${orden.numero ? orden.numero : ""}`, style: 'subheader' }]
                            ]
                        },

                        layout: 'noBorders'
                    }
                ]
            },
            {
                text: (empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + ' ' + empresa.apellidoPaterno + ' ' + empresa.apellidoMaterno)) + " / " + empresa.rfc,
                style: 'empresa',
                alignment: 'right',
                margin: [0, 0, 0, 0]
            },
            {
                style: 'infoTable',
                table: {
                    widths: [50, 215, 100, 40, 55, 40],
                    body: [
                        [
                            { text: 'OBRA:', style: 'fieldLabel' },
                            { text: nombreObra, style: 'fieldValue' },
                            { text: 'ENTRADA', style: 'fieldValue' },
                            { text: orden.entrada ? "X" : "", colSpan: 3, style: 'fieldValue' },
                            {},
                            {}
                        ],
                        [
                            { text: 'GESTOR', style: 'fieldLabel' },
                            { text: nombreGestor, style: 'fieldValue' },
                            { text: 'SALIDA:', style: 'fieldLabel' },
                            { text: !orden.entrada ? "X" : "", colSpan: 3, style: 'fieldValue' },
                            {},
                            {}
                        ],
                        [
                            { text: 'RESIDENTE:', style: 'fieldLabel' },
                            { text: nombreResidente, style: 'fieldValue' },
                            { text: 'FECHA TRASPASO:', style: 'fieldLabel' },
                            { text: moment(orden.fechaTraspaso ||orden.createdAt).format('DD/MM/YYYY'), colSpan: 3, style: 'fieldValue' },
                            {},
                            {},
                        ],
                        [
                            {},
                            {},
                            { text: 'FECHA REGISTRO:', style: 'fieldLabel' },
                            { text: moment(orden.createdAt).format('DD/MM/YYYY'), colSpan: 3, style: 'fieldValue' },
                            {},
                            {},
                        ]
                    ]
                }
            },
            { text: '', margin: [0, 3] },
            {
                style: 'infoTable',
                table: {
                    widths: [20, 60, 60, '*'],
                    body: [
                        [
                            { text: '', border: [true, true, true, true] },
                            { text: 'CÓDIGO', style: 'insumoHeader' },
                            { text: 'CANTIDAD', style: 'insumoHeader' },
                            { text: 'DESCRIPCIÓN', style: 'insumoHeader' }
                        ],
                        ...conceptos
                    ]
                },
            },
            { text: 'OBSERVACIONES', style: 'label', margin: [0, 10, 0, 2] },
            { text: orden.observaciones, style: 'fieldValue' },
            {
                columns: [
                    { text: '_______________________\n' + nombreAutorizo + 'AUTORIZÓ', style: 'label', alignment: 'center', margin: [0, 30, 0, 0] },
                    { text: '_______________________\n' + nombreConformidad + 'RECIBÍ DE CONFORMIDAD', alignment: 'center', margin: [0, 30, 0, 0], style: 'label' }
                ]
            }
        ],
        styles: {
            empresa: {
                fontSize: 8,
                bold: true
            },
            logo: {
                fontSize: 16,
                bold: true,
                color: '#C00000',
                margin: [0, 0, 0, 10]
            },
            header: {
                fontSize: 10,
                bold: true,
                color: 'white',
                fillColor: '#C00000',
                alignment: 'center',
                margin: [0, 0, 0, 2]
            },
            subheader: {
                fontSize: 8,
                alignment: 'center',
                bold: true,
                margin: [0, 0, 0, 5]
            },
            infoTable: {
                margin: [0, 10, 0, 5]
            },
            fieldLabel: {
                fontSize: 7,
                bold: true
            },
            fieldValue: {
                fontSize: 7
            },
            insumoHeader: {
                fontSize: 6,
                bold: true,
                fillColor: '#eee',
                alignment: 'center'
            },
            insumoCell: {
                fontSize: 6
            },
            label: {
                fontSize: 8,
                bold: true
            }
        },
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
    };
    return dd;
};

export default reciboTraspasoPdf;